export type Tab = 'files' | 'tree'

export const tabs: Record<Tab, { key: Tab; label: string }> = {
  tree: {
    key: 'tree',
    label: 'Anordnung',
  },
  files: {
    key: 'files',
    label: 'Dateien',
  },
}

// Block action (useBlockAction) held while the properties of the selected item
// have unsaved changes; deleting items in the structure waits for them
export const PROPERTIES_BLOCK_ACTION = 'document-manager-properties'

// Block action held while the structure (order, added items) has unsaved changes
export const STRUCTURE_BLOCK_ACTION = 'document-manager-structure'
